import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'vnm-batch-actions',
  templateUrl: './batch-actions.component.html',
  styleUrls: ['./batch-actions.component.scss']
})
export class BatchActionsComponent {
  @Input() disabled = false;
  @Input() label = 'app.batch-actions';
  @Input() model: MenuItem[];

  addItem(item: MenuItem) {
    if (!this.model) {
      this.model = [];
    }

    this.model = [...this.model, item];
  }

  removeItem(item: MenuItem) {
    const itemIndex = this.model.indexOf(item);
    if (itemIndex !== -1) {
      this.model.splice(itemIndex, 1);
      this.model = [...this.model];
    }
  }
}
